<template>
    <span v-if="value">{{ $t('[[[Tak]]]') }}</span>
    <span v-else>{{ $t('[[[Nie]]]') }}</span>
</template>

<script lang="ts">
import { Prop } from '@/helpers/Decorators';
import { Options, Vue } from 'vue-class-component';
import { Resource } from '@/helpers/Interfaces';

import { DynamicGridColumn } from '../../services/DynamicGridService';

@Options({})
export default class BooleanFormatter extends Vue
{
    @Prop()
    public configuration: DynamicGridColumn;
    @Prop()
    public item: Resource<any>;

    public get value(): boolean
    {
        const tmp = this.item.result[this.configuration.field] as boolean;

        return tmp;
    }
}
</script>
